import React from 'react';
import { CheckIcon, GlobeIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images, offerIncludes, offerPerks } from '../data/content';
const SPOTS_LEFT = 7;
const CLAIMED_PERCENT = 94;
export function Offer() {
  return <section id="offer" className="bg-brand-900 py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-218" data-mp="1ho5ys7q5p61u">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-219" data-mp="ty1v60cyx6au">
        <div className="text-center text-white" data-id="element-220" data-mp="u0xvfvcag72g">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-300" data-id="element-221" data-mp="p0tmqrhmggms">Special launch offer</p>
          <h2 id="offer-title" className="mt-3 font-serif text-[32px] font-extrabold leading-tight sm:text-5xl" data-id="element-222" data-mp="13y2kq41fkinh">
            Here’s everything you’ll receive <em className="text-brand-300" data-id="element-223" data-mp="z0aq329eiifl">today</em>
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-224" data-mp="2fad4jky754fs">
          <div className="bg-cream px-4 pt-6 sm:px-8" data-id="element-225" data-mp="2aclaoldzr88y">
            <img src={images.mockup} alt="Everything included in the CBCT Decision Map" className="mx-auto w-full max-w-lg" data-id="element-226" data-mp="pkh4r5ywamdk" />
          </div>

          <div className="px-5 py-8 sm:px-10" data-id="element-227" data-mp="uhqt0iajsrzt">
            <ul className="divide-y divide-brand-100" data-id="element-228" data-mp="ziertq50qd4l">
              {offerIncludes.map(o => <li key={o.label} className="flex items-center justify-between gap-4 py-4" data-id="element-229" data-mp="13jqb7dxau24c">
                  <span className="text-[17px] font-semibold text-ink" data-id="element-230" data-mp="6tprhtbsebtw">{o.label}</span>
                  <span className="shrink-0 text-sm font-bold text-muted" data-id="element-231" data-mp="6rwgk1u555g3">
                    Value: <span className="line-through decoration-alert" data-id="element-232" data-mp="bt2au43g90rq">${o.value}</span>
                  </span>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-233" data-mp="klnt7j3655g1">
                <span className="text-[17px] font-extrabold uppercase tracking-wide text-ink" data-id="element-234" data-mp="3k8m0yu8tq32k">Total value</span>
                <span className="font-serif text-2xl font-extrabold text-alert line-through" data-id="element-235" data-mp="3o9z7l6jqqaaj">$244</span>
              </li>
            </ul>

            <div className="mt-6 text-center" data-id="element-236" data-mp="vefta29km513">
              <p className="text-sm font-bold uppercase tracking-wider text-muted" data-id="element-237" data-mp="qgnr8ff7p2j6">
                Today you can get everything for just…
              </p>
              <p className="mt-2 font-serif text-[88px] font-black leading-none text-cta-dark sm:text-[112px]" data-id="element-238" data-mp="1550p5hxv0vgb">
                $27
                <span className="ml-2 align-top font-sans text-xl font-extrabold text-ink sm:text-2xl" data-id="element-239" data-mp="108tifmxn3fxb">USD</span>
              </p>
              <p className="mx-auto mt-3 flex max-w-sm items-center justify-center gap-2 rounded-full bg-brand-50 px-4 py-2 text-sm font-semibold text-brand-800" data-id="element-240" data-mp="7ibeykt07cjd">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-241" data-mp="lf84mixdynyo" />
                Currency is converted automatically to your local currency
              </p>
            </div>

            <ul className="mx-auto mt-6 grid max-w-md grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-242" data-mp="1wuwv3k9um548">
              {offerPerks.map(p => <li key={p} className="flex items-center gap-2.5 text-[16px] font-semibold text-ink" data-id="element-243" data-mp="20ex9k5bkvzw5">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-244" data-mp="25dgymelgxrsq">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-245" data-mp="1qh9flhlsqwf1" />
                  </span>
                  {p}
                </li>)}
            </ul>

            <div className="mt-8 rounded-2xl border-2 border-red-200 bg-red-50 p-4" data-id="element-246" data-mp="2j4lr8wqf5jtk">
              <p className="flex items-center gap-2 text-[15px] font-extrabold text-alert" data-id="element-247" data-mp="2o3yl41fpjr5n">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-248" data-mp="29fbzjhzhm35z" />
                Only {SPOTS_LEFT} spots left at the promotional price
              </p>
              <div className="relative mt-3 h-4 overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-249" data-mp="2eclvlghdtd2s">
                <div className="relative h-full overflow-hidden rounded-full bg-alert" style={{
                width: `${CLAIMED_PERCENT}%`
              }} data-id="element-250" data-mp="1e7bbx96xx2th">
                  <span className="animate-bar-shine absolute inset-y-0 w-1/3 bg-white/30" aria-hidden="true" data-id="element-251" data-mp="197f7j8ubz9de" />
                </div>
              </div>
              <p className="mt-2 text-right text-xs font-bold uppercase tracking-wide text-red-700" data-id="element-252" data-mp="14b86nugsko2b">
                {CLAIMED_PERCENT}% claimed
              </p>
            </div>

            <CtaButton className="mt-8" label="I want the CBCT Decision Map™" note="One-time payment of $27 USD · Instant access · Lifetime access · 7-Day Guarantee" data-id="element-253" data-mp="1wykwqem5ve0d" />

            <Countdown data-id="element-254" data-mp="1n65d7cv7uhdd" />

            <p className="mt-6 text-center text-sm text-muted" data-id="element-255" data-mp="2knx2t5m6z5yg">
              <span className="font-extrabold text-ink" data-id="element-256" data-mp="2kpgkn0nhxp2c">Launch price: $27.</span> The regular price will be higher after
              the launch period.
            </p>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[17px] leading-relaxed text-brand-100" data-id="element-257" data-mp="2o7e2ujxhcuh3">
          <span className="font-serif text-xl font-bold italic text-white" data-id="element-258" data-mp="2s8pu0tw05nre">
            For less than the cost of a typical clinical resource…
          </span>{' '}
          you’ll have a structured CBCT review system you can return to whenever you need to analyze an
          implant-related case.
        </p>
      </div>
    </section>;
}